import classNames from 'classnames';

import { formatDateLong, formatTime } from '@common/utils/date';
import { formatPrice } from '@common/utils/price';
import { LinkoutOriginPageTypes } from '@common/utils/tracking';
import { ProgrammeDetail, SupabaseEventRecord } from '@interfaces';

import styles from './listing-detail-header.module.scss';
import { ListingAnchors } from './ListingAnchors';
import { ListingBadgeList } from './ListingBadgeList';

interface ListingDetailHeaderProps {
	event: SupabaseEventRecord;
	programmeData: ProgrammeDetail;
	className?: string;
}

export const ListingDetailHeader = ({
	event,
	programmeData,
	className,
}: ListingDetailHeaderProps) => {
	const doorTime = event.door_time ? formatTime(event.door_time) : null;
	const curfewTime = event.curfew_time ? formatTime(event.curfew_time) : null;
	const representativeTicketPrice = event.representative_ticket_price
		? formatPrice({ cents: event.representative_ticket_price })
		: null;

	return (
		<header className={classNames(className, styles['listing-detail-header'])}>
			<ListingBadgeList
				className={styles['listing-detail-header__tags']}
				event={event}
				isVenueNameInMarquee
			/>
			<h1 className={styles['listing-detail-header__heading']} itemProp="name">
				{event.name}
			</h1>
			<time
				className={styles['listing-detail-header__date']}
				dateTime={event.start_date}
				itemProp="startDate"
			>
				{formatDateLong(event.start_date)}
			</time>
			{doorTime || curfewTime ? (
				<ul
					className={classNames(
						styles['listing-detail-header__times'],
						'list-unstyled',
					)}
				>
					{doorTime ? <li>Door Time: {doorTime}</li> : null}
					{curfewTime ? <li>Curfew: {curfewTime}</li> : null}
				</ul>
			) : null}
			<div className={styles['listing-detail-header__buy']}>
				{representativeTicketPrice ? (
					<div>
						<span className={styles['listing-detail-header__amount']}>
							{representativeTicketPrice}
						</span>{' '}
						{programmeData.labelTicketFeeDisclaimer}
					</div>
				) : null}
				<div className={styles['listing-detail-header__ticket-links']}>
					<ListingAnchors
						event={event}
						linkoutOriginPageType={LinkoutOriginPageTypes.EventPage}
						{...programmeData}
					/>
				</div>
			</div>
		</header>
	);
};
